import initialState from "./initialState";

export function CarrierStationReducer(
  state = initialState.carrierStationFormValues,
  action
) {
  switch (action.type) {
    case "CARRIER_STATION_FORM_DATA_REQUEST":
      return {
        ...state,
        carrierStationFormValues: action.payload,
      };
    default:
      return state;
  }
}